"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LinkButtonIcon = exports.LinkButton = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _Button = require("../../Button.styles");

var _Button2 = require("../../Button");

var LinkButton = _styledComponents["default"].a.withConfig({
  displayName: "LinkButtonstyles__LinkButton",
  componentId: "fsc7ri-0"
})(function (_ref) {
  var size = _ref.size,
      kind = _ref.kind,
      isFullWidth = _ref.isFullWidth,
      isActive = _ref.isActive,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "kind", "isFullWidth", "isActive"]);
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], _Button.commonStyles, _Button.sizeStyles[size], (0, _Button.kindStyles)(props)[kind], isFullWidth && _Button.fullWidthStyles, isActive ? _Button.activeStyles : _Button.inactiveStyles);
});

exports.LinkButton = LinkButton;
var LinkButtonIcon = (0, _styledComponents["default"])(_Button2.ButtonIcon).withConfig({
  displayName: "LinkButtonstyles__LinkButtonIcon",
  componentId: "fsc7ri-1"
})(["", " color:", ";margin-top:-", ";"], _stylers["default"].fontSize(-3), _tokens["default"].textColor.icon, _tokens["default"].spaceSm);
exports.LinkButtonIcon = LinkButtonIcon;
//# sourceMappingURL=LinkButton.styles.js.map